<template>
    <div
        class="w-max text-sm font-medium px-1.5 py-0.5 rounded-full"
        :class="configured
            ? 'bg-green-100 text-green-700'
            : 'bg-orange-100 text-orange-700'"
    >
        {{ configured
            ? t('widget.aiInstructions.configured')
            : t('widget.aiInstructions.notConfigured')
        }}
    </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

defineProps<{
    configured: boolean
}>()
</script>
